/**
 * @Author: yxp
 * @Date:   2017-07-05 10:07:13
 * @Last modified by:   yxp
 * @Last modified time: 2017-07-10 18:07:07
 */
import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.baseURL = `${location.protocol}//${location.host}`;

axios.interceptors.request.use((config) => {
  /* eslint max-len: ["error", 120] */
  /* eslint no-param-reassign: ["error",{"props":true,"ignorePropertyModificationsFor":["config"]}] */
  if (config.method === 'post' || config.method === 'put') {
    config.headers['Content-Type'] = 'application/json';
  }
  // Do something before request is sent
  return config;
});

// 实现类似vue-resource 的使用方式
axios.interceptors.request.use((config) => {
  const params = config.params || {};
  let url = config.url;
  url = url.replace(/\{(\/?)(\w+)\}/g, (match, slash, key) => {
    if (params[key]) {
      const value = params[key];
      delete params[key];
      return `${slash ? '/' : ''}${value || ''}`;
    }
    return '';
  });
  /* eslint no-param-reassign: ["error",{"props":true,"ignorePropertyModificationsFor":["config"]}] */
  config.url = url;
  config.params = params;
  return config;
});


axios.interceptors.response.use((resp) => {
  if (resp.data.status === 200) {
    return resp.data;
  }
  return Promise.reject(resp.data.msg);
}, (error) => {
  if (error) {
    return Promise.reject(error);
  }
  return Promise.reject('unknown error');
});

export default axios;



// WEBPACK FOOTER //
// ./src/services/axios.js